<template>
  <div class="code_share">
    <van-sticky>
      <van-nav-bar title="二维码分享" left-arrow @click-left="goback()" />

      <van-image
        width="100%"
        src="/static/images/index_bg.jpg"
        height="200"
        fit="cover"
      />

      <div class="share_img">
        <div ref="qrCodeUrl"></div>
      </div>
    </van-sticky>
  </div>
</template>
<script>
import { Button, NavBar, Icon, Sticky, Image } from "vant";
import QRCode from "qrcodejs2";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Image.name]: Image,
  },
  data() {
    return {};
  },
  mounted() {
    this.creatQrCode(this.$route.query.id);
  },

  methods: {
    creatQrCode(id) {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: "http://tgy.1688tg.com/mobile/#/login/signIn?recommendUserId="+id, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //跳转立即租赁
    toSiteLease() {
      this.$router.push({ path: "/home/siteLease" });
    },

    //跳转立即预约
    toSiteSubscribe() {
      this.$router.push({ path: "/home/siteSubscribe" });
    },
  },
};
</script>

<style lang="less" scoped>
.code_share {
  .share_img {
    display: flex;
    justify-content: center;
    margin-top: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/distribution/codeShare.vue